const getters = {
    purchaseinvoices: (state) => state.purchaseinvoices,
    purchaseinvoiceId: (state) =>state.purchaseinvoiceId,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;